import { render } from "./Limiti.vue?vue&type=template&id=19bc08d3&scoped=true"
import script from "./Limiti.vue?vue&type=script&lang=js"
export * from "./Limiti.vue?vue&type=script&lang=js"

import "./Limiti.vue?vue&type=style&index=0&id=19bc08d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19bc08d3"]])

export default __exports__